import { initialState } from './traduzioni.state';
import * as traduzioniActions from './traduzioni.actions';

/**
 * Funzione che gestisce gli aggiornamenti di stato dipendenti dalle azioni sulla pagina di traduzioni
 * @param state {State} stato a livello dello store di traduzioni, inizialmente settato a initialState
 * @param action {TraduzioniAction} le azioni disponibili per lo store di traduzioni
 */
export function traduzioniReducer(state = initialState, action: traduzioniActions.TraduzioniAction) {
    switch (action.type) {
        case traduzioniActions.SELECT_RESOURCE: {
            return {
                ...state,
                selectedResource: action.payload
            }
        }
        case traduzioniActions.UPDATE_FILTER: {
            return {
                ...state,
                filters: action.payload
            };
        };
        case traduzioniActions.SET_SELECTION_TABLE_ROW: {
            return {
                ...state,
                selectedRow: action.payload,
                secondarySelectedRows: []
            };
        };
        case traduzioniActions.SET_SECONDARY_SELECTION_TABLE_ROWS: {
            return {
                ...state, 
                secondarySelectedRows: action.payload
            };
        };
        default: {
            return {
                ...state
            };
        };
    }
}